<template>
    <div>
        <div class="container">
            <div class="handle-box">
                <div id="extend-upload-chooseFile" style="float: left; margin: 0px 5px;">
                    <i class="el-icon-plus"></i> 选择文件
                </div>
                <el-button
                    type="success"
                    :icon="uploadStaus"
                    class="handle-del mr10"
                    @click="uploadToServer()"
                    :disabled="uploadBtnDisabled"
                >开始上传</el-button>
                <el-button
                    type="danger"
                    icon="el-icon-close"
                    class="handle-del mr10"
                    @click="clearFiles()"
                    :disabled="uploadBtnDisabled"
                >清空文件</el-button>
            </div>
            <div class="showMsg">支持上传的文件后缀：{{ options.fileType }}</div>
            <div id="dndArea" class="dnd-area">
                拖拽文件到此区域
            </div>
            <el-table :data="fileListData" style="width: 100%">
                <el-table-column prop="fileName" label="文件名称" align="center" width="180"></el-table-column>
                <el-table-column prop="fileSize" align="center" label="文件大小" width="180"></el-table-column>
                <el-table-column prop="progress" align="center" label="进度"></el-table-column>
                <el-table-column label="操作" width="200" align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-close" class="red" @click="removeRow(scope.$index, scope.row)">移除</el-button>
                        <el-button type="text" icon="el-icon-search" class="red" @click="seeFile(scope.$index, scope.row)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import $ from 'jquery'
import webUploader from 'webuploader'

export default {
    name: 'webupload',
    props: {
        headers: {
            type: String,
            default: ''
        },
        fileNumLimit: {
            type: Number,
            default: 500
        },
        fileSize: {
            type: Number,
            default: 100 * 1024 * 1024 * 1024
        },
        chunkSize: {
            type: Number,
            default: 2 * 1024 * 1024
        },
        uploadSuffixUrl: {
            type: String,
            default: 'http://localhost:18288'
        },
        options: {
            type: Object,
            default: () => ({
                fileType: "doc,docx,pdf,xls,xlsx,ppt,pptx,txt,gif,jpg,jpeg,bmp,png,rar,zip,mp4,avi,dmg,sql,7z,apk,ipa,gz,rpm,pkg,ovpn",
                fileUploadUrl: "/upload/upload",
                mergeChunksUrl: "/upload/merge",
                headers: {}
            })
        },
        fileListData: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            uploader: {},
            uploadBtnDisabled: false,
            uploadStaus: "el-icon-upload",
            fList: [],
            uuid: {}
        }
    },
    mounted() {
        this.register();
        this.createUploader();
        this.events();
    },
    methods: {
        createUploader() {
            var fileType = this.options.fileType;
            this.uploader = webUploader.create({
                resize: false,
                swf: '../../../assets/Uploader.swf',
                server: this.uploadSuffixUrl + this.options.fileUploadUrl,
                pick: {
                    id: '#extend-upload-chooseFile',
                    multiple: true
                },
                dnd: '#dndArea',
                accept: [{
                    title: 'file',
                    extensions: fileType,
                    mimeTypes: this.buildFileType(fileType)
                }],
                headers: this.options.headers || {},
                compressSize: 0,
                fileNumLimit: this.fileNumLimit,
                fileSizeLimit: 100 * 1024 * 1024 * 1024,
                fileSingleSizeLimit: this.fileSize,
                chunked: true,
                threads: 1,
                chunkSize: this.chunkSize,
                prepareNextFile: false
            });
        },
        register() {
            var that = this;
            var options = this.options;
            var headers = options.headers || {};
            var uploadSuffixUrl = this.uploadSuffixUrl;
            var mergeChunksUrl = uploadSuffixUrl + options.mergeChunksUrl;

            webUploader.Uploader.register({
                "after-send-file": "afterSendFile"
            }, {
                afterSendFile: function (file) {
                    $.ajax({
                        type: "POST",
                        url: mergeChunksUrl,
                        headers: headers,
                        dataType: "JSON",
                        data: { guid: that.uuid[file.id], fileName: file.name, uid: localStorage.getItem('uid') },
                        success: function (resdata) {
                            if (resdata.msg == 'success') {
                                var data = resdata.data;
                                that.uploader.skipFile(file);
                                delete that.uuid[file.id];
                                that.setTableBtn(file.id, '上传成功', data.url);
                                that.fList.push(data);
                            }
                        }
                    });
                }
            });
        },
        events() {
            var that = this;
            var uplaod = this.uploader;

            uplaod.on('fileQueued', function (file) {
                var fileSize = that.formatFileSize(file.size);
                var row = { fileId: file.id, fileName: file.name, fileSize: fileSize, validateMd5: '0%', progress: "等待上传", state: '就绪' };
                Vue.set(that.uuid, file.id, webUploader.Base.guid());
                that.fileListData.push(row);
            });

            uplaod.on('uploadProgress', function (file, percentage) {
                that.setTableBtn(file.id, (percentage * 100).toFixed(2) + '%');
            });

            uplaod.on('uploadBeforeSend', function (block, data, headers) {
                data.guid = that.uuid[block.file.id];
                data.fileMd5 = block.file.fileMd5;
                data.contentType = block.file.type;
                data.chunks = block.chunks;
                data.chunk = block.chunk;
                headers.Authorization = that.options.headers.Authorization;
            });

            uplaod.on('error', function (handler) {
                if (handler == 'F_EXCEED_SIZE') {
                    that.$message.error({
                        showClose: true,
                        message: '上传的单个太大!\n最大支持' + that.formatFileSize(that.fileSize) + '! \n操作无法进行,如有需求请联系管理员'
                    });
                } else if (handler == 'Q_TYPE_DENIED') {
                    that.$message.error({
                        showClose: true,
                        message: '不允许上传此类文件, 操作无法进行, 如有需求请联系管理员'
                    });
                }
            });

            uplaod.on('fileDequeued', function (file) {});

            uplaod.on('uploadSuccess', function (file, response) {
                if (response.success) {
                    that.setTableBtn(file.id, '正在校验文件...');
                }
            });

            uplaod.on('uploadFinished', function () {
                that.uploadBtnDisabled = false;
                that.uploadStaus = "el-icon-upload";
                that.$message.success({
                    showClose: true,
                    message: '文件上传完毕'
                });
            });
        },
        setTableBtn(fileId, showmsg, networkPath) {
            var fileList = this.fileListData;
            for (var i = 0; i < fileList.length; i++) {
                if (fileList[i].fileId == fileId) {
                    this.fileListData[i].progress = showmsg;
                    this.fileListData[i].networkPath = networkPath || "";
                }
            }
        },
        removeRow(index, row) {
            this.uploader.removeFile(row.fileId);
            this.fileListData.splice(index, 1);
        },
        seeFile(index, row) {
            var npath = row.networkPath;
            if (this.strIsNull(npath)) {
                this.$message.error({
                    showClose: true,
                    message: '文件未上传，请等待文件上传完成后，方可查看'
                });
                return;
            }
            var filens = npath.substring(npath.lastIndexOf(".") + 1);
            if (filens == "png" || filens == "jpg" || filens == "jpeg" || filens == "gif") {
                this.$message.success({
                    dangerouslyUseHTMLString: true,
                    showClose: true,
                    message: `<img src="${this.uploadSuffixUrl + npath}" style="max-width: 80%;max-height: 80%;"/>`
                });
            } else {
                window.open(this.uploadSuffixUrl + npath);
            }
        },
        uploadToServer() {
            if (this.fileListData.length <= 0) {
                this.$message.error({
                    showClose: true,
                    message: '没有上传的文件'
                });
                return;
            }
            this.uploadBtnDisabled = true;
            this.uploadStaus = "el-icon-loading";
            $("#extent-button-uploader").text("正在上传，请稍等...");
            this.uploader.upload();
        },
        clearFiles() {
            this.uploadBtnDisabled = false;
            this.uploadStaus = "el-icon-upload";
            this.uploader.reset();
            this.fileListData = [];
        },
        buildFileType(fileType) {
            var ts = fileType.split(',');
            var ty = '';

            for (var i = 0; i < ts.length; i++) {
                ty = ty + "." + ts[i] + ",";
            }
            return ty.substring(0, ty.length - 1);
        },
        strIsNull(str) {
            return typeof str == "undefined" || str == null || str == "";
        },
        formatFileSize(size) {
            var fileSize = 0;
            if (size / 1024 > 1024) {
                var len = size / 1024 / 1024;
                fileSize = len.toFixed(2) + "MB";
            } else if (size / 1024 / 1024 > 1024) {
                var len = size / 1024 / 1024;
                fileSize = len.toFixed(2) + "GB";
            } else {
                var len = size / 1024;
                fileSize = len.toFixed(2) + "KB";
            }
            return fileSize;
        }
    }
}
</script>

<style>
.container {
    padding: 30px;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 5px;
}
.handle-box {
    margin-bottom: 20px;
}
#picker div:nth-child(2) {
    width: 100% !important;
    height: 100% !important;
}
.webuploader-container {
    position: relative;
}
.webuploader-element-invisible {
    position: absolute !important;
    clip: rect(1px 1px 1px 1px); /* IE6, IE7 */
    clip: rect(1px, 1px, 1px, 1px);
}
.webuploader-pick {
    position: relative;
    display: inline-block;
    cursor: pointer;
    background: #409eff;
    padding: 8px 12px;
    color: #fff;
    font-size: 10px;
    text-align: center;
    border-radius: 3px;
    overflow: hidden;
}
.webuploader-pick-hover {
    background: #409EFF;
}
.showMsg {
    margin: 5px;
    background: radial-gradient(#d2b8b8, transparent);
}
.dnd-area {
    border: 2px dashed #409eff;
    padding: 20px;
    text-align: center;
    margin-bottom: 20px;
    color: #409eff;
    font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/upload/WebUpload.vue